var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#146EB4",
    d: "M7 1.094c.34 0 .626.251.672.586l.006.091v4.551h4.55c.35 0 .638.264.674.604l.004.074c0 .34-.252.626-.596.673l-.081.005H7.678v4.55c0 .35-.265.638-.604.674L7 12.906c-.34 0-.626-.252-.673-.596l-.005-.081V7.677h-4.55c-.35 0-.638-.264-.674-.603L1.094 7c0-.34.251-.626.596-.673l.081-.005h4.551v-4.55c0-.35.265-.638.604-.675L7 1.095z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#146EB4",
    fillRule: "evenodd",
    d: "M7 .919c.428 0 .788.317.845.737l.002.012.006.104v4.376h4.376c.44 0 .801.332.847.76l.001.009.005.083c0 .43-.32.788-.749.846l-.006.001-.098.006H7.853v4.376c0 .44-.333.801-.76.848h-.01L7 13.083c-.43 0-.788-.319-.846-.748l-.001-.007-.006-.098V7.852H1.771c-.44 0-.801-.332-.847-.76l-.001-.009L.918 7c0-.43.32-.788.749-.846h.006l.098-.007h4.376V1.772c0-.44.333-.802.76-.848l.01-.001L7 .919zm-.678 5.403h-4.55l-.082.005c-.345.047-.596.333-.596.673l.004.074c.036.34.324.604.673.604h4.551v4.55l.005.082c.047.345.333.596.673.596l.074-.003c.34-.037.604-.325.604-.674V7.678h4.55l.082-.005c.345-.047.596-.333.596-.673l-.004-.074c-.036-.34-.324-.604-.673-.604H7.677v-4.55l-.005-.092c-.046-.334-.332-.586-.672-.586l-.074.004c-.34.036-.604.324-.604.674v4.55z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconBlue);
export default __webpack_public_path__ + "static/media/plus-icon-blue.e3694f48bf47b1b821d892d16e03596a.svg";
export { ForwardRef as ReactComponent };